import React, { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";

export default function Activate() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== password2) { setError("Las contraseñas no coinciden."); return; }
    if (password.length < 6) { setError("La contraseña debe tener al menos 6 caracteres."); return; }
    setLoading(true);
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/auth/activate`, { token, username, password });
      setSuccess(true);
      setTimeout(() => navigate("/login"), 2500);
    } catch (err) {
      setError(err.response?.data?.message || "Error al activar la cuenta.");
    } finally {
      setLoading(false);
    }
  };

  if (!token) return (
    <div className="main-content">
      <div className="empty-state"><p>Enlace de activación inválido.</p></div>
    </div>
  );

  if (success) return (
    <div className="main-content">
      <div className="empty-state">
        <div className="empty-state-icon">✅</div>
        <p>Cuenta activada correctamente. Redirigiendo al login...</p>
      </div>
    </div>
  );

  return (
    <div className="main-content" style={{ maxWidth: 420, margin: "60px auto" }}>
      <div className="location-card">
        <h2 className="dashboard-title">Activar cuenta</h2>
        <p style={{ color: "var(--muted)", marginBottom: 24 }}>
          Elige un nombre de usuario y contraseña para acceder al sistema.
        </p>
        {error && <div className="alert-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Nombre de usuario</label>
            <input
              type="text" value={username} required
              onChange={e => setUsername(e.target.value)}
              placeholder="vecino1"
            />
          </div>
          <div className="form-group">
            <label>Contraseña</label>
            <input
              type="password" value={password} required
              onChange={e => setPassword(e.target.value)}
              placeholder="Mínimo 6 caracteres"
            />
          </div>
          <div className="form-group">
            <label>Repetir contraseña</label>
            <input
              type="password" value={password2} required
              onChange={e => setPassword2(e.target.value)}
              placeholder="Repite la contraseña"
            />
          </div>
          <button type="submit" className="btn-action" disabled={loading} style={{ width: "100%", marginTop: 8 }}>
            {loading ? "Activando..." : "Activar cuenta"}
          </button>
        </form>
      </div>
    </div>
  );
}
